module.exports = __webpack_public_path__ + "r-v3/img/ico_x_white.18d36277.svg";